import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.598 2.77125C6.96613 2.42365 9.35649 2.24952 11.75 2.25025C14.18 2.25025 16.567 2.42825 18.902 2.77025C20.88 3.06225 22.25 4.79425 22.25 6.74025V12.7602C22.25 14.7062 20.88 16.4382 18.902 16.7302C17.7483 16.8993 16.5889 17.0271 15.426 17.1132C15.3668 17.1171 15.3093 17.1345 15.2579 17.1639C15.2064 17.1934 15.1623 17.2342 15.129 17.2832L12.374 21.4162C12.3055 21.519 12.2127 21.6032 12.1039 21.6614C11.995 21.7197 11.8735 21.7502 11.75 21.7502C11.6265 21.7502 11.505 21.7197 11.3961 21.6614C11.2873 21.6032 11.1945 21.519 11.126 21.4162L8.371 17.2832C8.33768 17.2342 8.29361 17.1934 8.24214 17.1639C8.19068 17.1345 8.13317 17.1171 8.074 17.1132C6.91113 17.0267 5.75172 16.8987 4.598 16.7292C2.62 16.4392 1.25 14.7052 1.25 12.7592V6.74125C1.25 4.79525 2.62 3.06125 4.598 2.77125Z"
        fill={colorValue}
      />
    </svg>
  );
};
